





















































































import Vue from 'vue'
import Footer from './components/Footer.vue'
import Message from './components/Message.vue'
import ClickAway from './components/ClickAway.vue'
import Component from 'vue-class-component'
import { Action, State } from 'vuex-class'
import { ProfileState } from './store/profile/types'

const DEFAULT_TRANSITION = 'fade'

@Component({
  components: {
    Message,
    Footer,
    ClickAway
  }
})
export default class App extends Vue {
  showUserMenu = false
  showMenu = false

  transitionName = DEFAULT_TRANSITION

  // TODO Default to fade
  transitionEnterActiveClass = ''
  transitionEnterToClass = ''
  transitionEnterClass = ''
  transitionLeaveClass = ''
  transitionLeaveActiveClass = ''
  transitionLeaveToClass = ''

  // eslint-disable-next-line
  @Action('logout', { namespace: 'profile' }) profileLogout: any

  @State('profile') private profile!: ProfileState

  created () {
    this.$router.beforeEach((to, from, next) => {
      const transitionName = to.meta.transitionName || from.meta.transitionName || DEFAULT_TRANSITION
      if (transitionName === 'zoom') {
        this.transitionEnterActiveClass = 'transition-all duration-75 ease-out'
        this.transitionEnterToClass = 'transform opacity-100 scale-100'
        this.transitionEnterClass = 'transform opacity-0 scale-0'
        this.transitionLeaveClass = 'transform opacity-100 scale-100'
        this.transitionLeaveActiveClass = 'transition-all duration-200 ease-in'
        this.transitionLeaveToClass = 'transform opacity-0 scale-0'
      } else {
        this.transitionEnterActiveClass = 'transition-all transition-fastest ease-out-quad'
        this.transitionEnterToClass = 'opacity-100 scale-100'
        this.transitionEnterClass = 'opacity-0 scale-70'
        this.transitionLeaveClass = 'opacity-100 scale-100'
        this.transitionLeaveActiveClass = 'transition-all transition-faster ease-in-quad'
        this.transitionLeaveToClass = 'opacity-0 scale-70'
      }
      next()
    })
  }

  logout () {
    this.profileLogout() // vuex logout action

    this.showUserMenu = false // close user menu

    // TODO this could also be done in vuex logout action
    // if current route requires authentication, return to home
    if (this.$route.meta.requiresAuth) {
      this.$router.push('/')
    }
  }
}
